export default __webpack_public_path__ + "top_outlaw.68bcab.png";